(function () {
  'use strict';

  var STORAGE_KEY = 'sheetshark_wishlist';
  var HEART_ANIM_MS = 600;

  function animationsEnabled() {
    return document.body.getAttribute('data-disable-animations') !== 'true';
  }
  function getSettings() {
    return window.theme && window.theme.wishlistSettings
      ? window.theme.wishlistSettings
      : { enabled: true, pageUrl: '/pages/wishlist' };
  }

  function readStore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeStore(items) {
    var prevCount = readStore().length;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    updateCountBadges(items.length, prevCount);
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
  }

  function getItemFromButton(btn) {
    return {
      handle: btn.getAttribute('data-product-handle') || '',
      id: String(btn.getAttribute('data-product-id') || ''),
      title: btn.getAttribute('data-product-title') || '',
      url: btn.getAttribute('data-product-url') || '',
      image: btn.getAttribute('data-product-image') || '',
      price: btn.getAttribute('data-product-price') || ''
    };
  }

  function isInWishlist(handle) {
    if (!handle) return false;
    return readStore().some(function (item) {
      return item.handle === handle;
    });
  }

  function updateButtonState(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function animateHeaderWishlist(added) {
    if (!animationsEnabled()) return;
    var popAnimName = 'wishlist-header-heart-pop';

    document.querySelectorAll('.header-wishlist-link, .js-wishlist-header-link').forEach(function (link) {
      var iconWrap = link.querySelector('.header-wishlist-heart__icons');
      if (!iconWrap) return;

      link.classList.remove(
        'is-header-wishlist-animating',
        'is-header-wishlist-animating--add',
        'is-header-wishlist-animating--remove'
      );
      void link.offsetWidth;
      link.classList.add(
        'is-header-wishlist-animating',
        added ? 'is-header-wishlist-animating--add' : 'is-header-wishlist-animating--remove'
      );

      var cleaned = false;
      var heartCleanup = function (e) {
        if (cleaned) return;
        if (e && e.animationName && e.animationName !== popAnimName) return;
        cleaned = true;
        link.classList.remove(
          'is-header-wishlist-animating',
          'is-header-wishlist-animating--add',
          'is-header-wishlist-animating--remove'
        );
        if (!added && readStore().length === 0) {
          link.classList.remove('has-wishlist-items');
        }
        iconWrap.removeEventListener('animationend', heartCleanup);
      };
      iconWrap.addEventListener('animationend', heartCleanup);
      setTimeout(heartCleanup, HEART_ANIM_MS + 50);
    });
  }

  function syncHeaderWishlistState(count) {
    document.querySelectorAll('.header-wishlist-link, .js-wishlist-header-link').forEach(function (link) {
      if (count > 0) {
        link.classList.add('has-wishlist-items');
      } else if (!link.classList.contains('is-header-wishlist-animating--remove')) {
        link.classList.remove('has-wishlist-items');
      }
    });
  }

  function updateCountBadges(count, prevCount) {
    document.querySelectorAll('.js-wishlist-count').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.classList.toggle('wishlist-link__bubble--visible', count > 0);
      el.classList.toggle('two-digit', count >= 10);
    });
    syncHeaderWishlistState(count);
    if (typeof prevCount === 'number' && count > prevCount) {
      animateHeaderWishlist(true);
    } else if (typeof prevCount === 'number' && count < prevCount) {
      animateHeaderWishlist(false);
    }
  }

  function animateHeart(btn, added) {
    if (!animationsEnabled() || !btn) return;

    btn.classList.remove('is-wishlist-animating', 'is-wishlist-animating--add', 'is-wishlist-animating--remove');
    void btn.offsetWidth;
    btn.classList.add(
      'is-wishlist-animating',
      added ? 'is-wishlist-animating--add' : 'is-wishlist-animating--remove'
    );

    var iconWrap = btn.querySelector('.wishlist-heart__icons') || btn;
    var cleanup = function (e) {
      if (e && e.animationName && e.animationName !== 'wishlist-heart-pop') return;
      btn.classList.remove('is-wishlist-animating', 'is-wishlist-animating--add', 'is-wishlist-animating--remove');
      iconWrap.removeEventListener('animationend', cleanup);
    };
    iconWrap.addEventListener('animationend', cleanup);
    setTimeout(function () {
      cleanup();
    }, HEART_ANIM_MS + 50);
  }

  function syncButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('.js-wishlist-toggle').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      updateButtonState(btn, isInWishlist(handle));
    });
  }

  function toggleWishlist(btn) {
    var item = getItemFromButton(btn);
    if (!item.handle) return;

    var items = readStore();
    var index = items.findIndex(function (entry) {
      return entry.handle === item.handle;
    });

    var added = index === -1;

    if (added) {
      items.unshift(item);
    } else {
      items.splice(index, 1);
    }

    writeStore(items);
    syncButtons(document);
    animateHeart(btn, added);
  }

  var productCache = {};

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/'/g, '&#39;');
  }

  function getWishlistPageConfig() {
    var section = document.querySelector('[data-wishlist-section]');
    if (!section) return null;
    return {
      section: section,
      showAtc: section.getAttribute('data-show-atc') === 'true',
      atcText: section.getAttribute('data-atc-text') || 'Add to cart',
      atcStyle: section.getAttribute('data-atc-style') || 'solid',
      imageRatio: section.getAttribute('data-image-ratio') || 'natural'
    };
  }

  function heartButtonHtml(item) {
    return (
      '<button type="button" class="wishlist-heart wishlist-heart--grid js-wishlist-toggle is-active" ' +
        'data-product-handle="' + escapeAttr(item.handle) + '" ' +
        'data-product-id="' + escapeAttr(item.id) + '" ' +
        'data-product-title="' + escapeAttr(item.title) + '" ' +
        'data-product-url="' + escapeAttr(item.url) + '" ' +
        'data-product-image="' + escapeAttr(item.image) + '" ' +
        'data-product-price="' + escapeAttr(item.price) + '" ' +
        'aria-label="Remove from wishlist" aria-pressed="true">' +
        '<span class="wishlist-heart__icons" aria-hidden="true">' +
          '<svg class="wishlist-heart__icon wishlist-heart__icon--outline" width="22" height="22" viewBox="0 0 24 24" fill="none" focusable="false"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>' +
          '<svg class="wishlist-heart__icon wishlist-heart__icon--filled" width="22" height="22" viewBox="0 0 24 24" fill="currentColor" focusable="false"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>' +
        '</span>' +
      '</button>'
    );
  }

  function atcButtonHtml(variantId, available, config) {
    if (!config.showAtc || !variantId) return '';
    var disabled = available === false ? ' disabled aria-disabled="true"' : '';
    return (
      '<div class="fc-atc">' +
        '<form method="post" action="/cart/add" data-fc-atc>' +
          '<input type="hidden" name="id" value="' + escapeAttr(variantId) + '">' +
          '<button type="submit" class="btn fc-atc-btn fc-atc--' + escapeAttr(config.atcStyle) + '"' + disabled + '>' +
            '<span class="fc-atc-label">' + escapeHtml(config.atcText) + '</span>' +
            '<span class="fc-atc-spinner" aria-hidden="true"></span>' +
            '<svg class="fc-atc-check" viewBox="0 0 16 12" aria-hidden="true"><path d="M1 7 L6 11 L15 1"></path></svg>' +
          '</button>' +
        '</form>' +
      '</div>'
    );
  }

  function priceHtml(item, product) {
    if (product && product.variants && product.variants.length) {
      var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      if (variant) {
        var compareAt = variant.compare_at_price;
        var price = variant.price;
        if (compareAt && compareAt > price) {
          return (
            '<div class="grid-product__price">' +
              '<span class="money">' + escapeHtml(formatMoney(price)) + '</span>' +
              '<s class="money">' + escapeHtml(formatMoney(compareAt)) + '</s>' +
            '</div>'
          );
        }
        return '<div class="grid-product__price"><span class="money">' + escapeHtml(formatMoney(price)) + '</span></div>';
      }
    }
    if (item.price) {
      return '<div class="grid-product__price"><span class="money">' + escapeHtml(item.price) + '</span></div>';
    }
    return '';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = window.theme && window.theme.moneyFormat;
      return window.Shopify.formatMoney(cents, format);
    }
    return (Number(cents) / 100).toFixed(2);
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('product fetch failed');
        return res.json();
      })
      .then(function (product) {
        productCache[handle] = product;
        return product;
      })
      .catch(function () {
        return null;
      });
  }

  function buildTileHtml(item, product, config) {
    var url = item.url || '#';
    var title = item.title || '';
    var ratio = config.imageRatio || 'natural';
    var ratioClass = ratio === 'natural' ? '' : ' fc-ratio--' + ratio;
    var imageBlock = item.image
      ? '<img src="' + escapeAttr(item.image) + '" alt="' + escapeAttr(title) + '" loading="lazy" width="600" height="600" class="fc-media__img--first">'
      : '<div class="fc-media__placeholder" aria-hidden="true"></div>';

    var variant = null;
    var variantId = '';
    var available = true;
    if (product && product.variants && product.variants.length) {
      variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      if (variant) {
        variantId = variant.id;
        available = variant.available;
      }
    }

    return (
      '<div class="grid__item grid-product" role="listitem" data-product-handle="' + escapeAttr(item.handle) + '">' +
        '<div class="grid-product__content">' +
          '<div class="fc-media-wrap">' +
            '<a href="' + escapeAttr(url) + '" class="grid-product__link" style="display:block; position:relative; z-index:1;">' +
              '<div class="fc-media' + ratioClass + '">' +
                '<div class="fc-media__inner">' +
                  '<div class="image-wrap">' + imageBlock + '</div>' +
                '</div>' +
              '</div>' +
            '</a>' +
            '<div class="wishlist-heart-wrap wishlist-heart-wrap--grid">' + heartButtonHtml(item) + '</div>' +
          '</div>' +
          atcButtonHtml(variantId, available, config) +
          '<div class="grid-product__meta">' +
            '<div class="grid-product__title"><a href="' + escapeAttr(url) + '">' + escapeHtml(title) + '</a></div>' +
            priceHtml(item, product) +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function initWishlistHearts(root) {
    if (!getSettings().enabled) return;
    var scope = root || document;
    syncButtons(scope);
    updateCountBadges(readStore().length);
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    var empty = document.querySelector('[data-wishlist-empty]');
    var config = getWishlistPageConfig() || { showAtc: false, atcText: 'Add to cart', atcStyle: 'solid', imageRatio: 'square' };
    var items = readStore();

    grid.innerHTML = '';

    if (!items.length) {
      if (empty) empty.hidden = false;
      grid.hidden = true;
      return;
    }

    if (empty) empty.hidden = true;
    grid.hidden = false;

    Promise.all(
      items.map(function (item) {
        return fetchProduct(item.handle).then(function (product) {
          return { item: item, product: product };
        });
      })
    ).then(function (rows) {
      if (!document.contains(grid)) return;
      var current = readStore();
      if (!current.length) return;

      grid.innerHTML = rows
        .map(function (row) {
          return buildTileHtml(row.item, row.product, config);
        })
        .join('');

      syncButtons(grid);
    });
  }

  function openCartDrawer() {
    try {
      var drawer = document.getElementById('CartDrawer') ||
        document.querySelector('cart-drawer') ||
        document.querySelector('.cart-drawer, .drawer--cart, .drawer--right');
      if (!drawer) return false;
      if (typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      document.documentElement.classList.add('js-drawer-open');
      document.body.classList.add('js-drawer-open');
      drawer.classList.add('is-open', 'open', 'active', 'drawer--is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.dispatchEvent(new CustomEvent('cart:open'));
      return true;
    } catch (e) {
      return false;
    }
  }

  function fetchCartAndNotify() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (cart) {
        if (!cart) return null;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function lockAtcButton(btn, locked) {
    if (!btn) return;
    if (locked) {
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
      btn.dataset.wlAtcLocked = 'true';
    } else {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
      delete btn.dataset.wlAtcLocked;
    }
  }

  function handleWishlistAtc(form, btn) {
    if (!form || !btn || btn.dataset.wlAtcLocked === 'true' || form.dataset.wlSubmitting === 'true') return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;

    form.dataset.wlSubmitting = 'true';
    lockAtcButton(btn, true);

    var body = new FormData(form);
    if (!body.get('quantity')) body.set('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: body
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed');
        return res.json();
      })
      .then(function () {
        return fetchCartAndNotify();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        setTimeout(function () {
          btn.classList.remove('is-success');
        }, 900);
        setTimeout(function () {
          if (!openCartDrawer()) window.location.href = '/cart';
        }, 80);
      })
      .catch(function () {
        window.location.href = '/cart';
      })
      .finally(function () {
        setTimeout(function () {
          lockAtcButton(btn, false);
          delete form.dataset.wlSubmitting;
        }, 300);
      });
  }

  function onWishlistAtcSubmit(e) {
    var section = document.querySelector('[data-wishlist-section]');
    if (!section) return;

    var form = e.target.closest ? e.target.closest('form[data-fc-atc]') : null;
    if (!form || !section.contains(form)) return;

    var btn = form.querySelector('.fc-atc-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    handleWishlistAtc(form, btn);
  }

  function onWishlistClick(e) {
    var btn = e.target && e.target.closest ? e.target.closest('.js-wishlist-toggle') : null;
    if (!btn || !getSettings().enabled) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }
    toggleWishlist(btn);
    if (document.querySelector('[data-wishlist-grid]')) {
      renderWishlistPage();
    }
    return false;
  }

  document.addEventListener('click', onWishlistClick, true);
  document.addEventListener('submit', onWishlistAtcSubmit, true);

  function bootWishlist() {
    initWishlistHearts(document);
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWishlist);
  } else {
    bootWishlist();
  }

  document.addEventListener('collection:updated', function () {
    initWishlistHearts(document);
  });

  document.addEventListener('shopify:section:load', function () {
    initWishlistHearts(document);
    renderWishlistPage();
  });

  document.addEventListener('wishlist:updated', function () {
    renderWishlistPage();
  });

  window.theme = window.theme || {};
  window.theme.wishlist = {
    read: readStore,
    init: initWishlistHearts,
    renderPage: renderWishlistPage
  };
})();
